module.exports = __webpack_public_path__ + "img/no-feed-data.51cfa5d4.svg";